import { motion, useSpring, useTransform } from "framer-motion";

export const BALLS = [
  { id: "game", label: "Game" },
  { id: "fluoro", label: "Fluoro" },
  { id: "splatter", label: "Splatter" },
];

const PHOTO_VARIANTS = {
  game: { src: "/images/pow-game.jpg", zoom: 1.3 },
  splatter: { src: "/images/pow-splatter.jpg", zoom: 1.15 },
  fluoro: { src: "/images/pow-fluoro-yellow.jpg", zoom: 1.25 },
};

export const Sphere = ({ variant, mx, my }) => {
  const sx = useSpring(mx, { stiffness: 80, damping: 18 });
  const sy = useSpring(my, { stiffness: 80, damping: 18 });
  const rotateY = useTransform(sx, [-0.5, 0.5], [-28, 28]);
  const rotateX = useTransform(sy, [-0.5, 0.5], [22, -22]);
  const hx = useTransform(sx, [-0.5, 0.5], ["22%", "48%"]);
  const hy = useTransform(sy, [-0.5, 0.5], ["18%", "42%"]);

  return (
    <div className="h-full w-full [perspective:900px]">
      <motion.div style={{ rotateX, rotateY, "--hx": hx, "--hy": hy }} className="h-full w-full [transform-style:preserve-3d]">
        <motion.div
          key={variant}
          initial={{ scale: 0.85, opacity: 0.4 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 160, damping: 14 }}
          data-testid="hero-sphere"
          className={`h-full w-full ${PHOTO_VARIANTS[variant] ? "rounded-full shadow-[0_45px_70px_-25px_rgba(0,0,0,0.7)] overflow-hidden" : `pow-sphere pow-sphere--${variant}`}`}
        >
          {PHOTO_VARIANTS[variant] ? (
            <img
              src={PHOTO_VARIANTS[variant].src}
              alt={`POW ${variant} ball`}
              className="sphere-photo h-full w-full object-cover"
              style={{ transform: `scale(${PHOTO_VARIANTS[variant].zoom})` }}
            />
          ) : null}
        </motion.div>
      </motion.div>
    </div>
  );
};
